module.exports = __webpack_public_path__ + "static/media/010_DSC0391.1b041236.jpg";